import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Kontakt = () => {
  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Kontakt</h1>
          <p className="page-subtitle">
            Wir sind für Sie da
          </p>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div className="kontakt-grid">
            <div className="kontakt-info">
              <Card className="kontakt-card">
                <CardContent className="kontakt-card-content">
                  <Phone className="kontakt-icon" />
                  <h3 className="kontakt-title">Telefon</h3>
                  <p className="kontakt-detail">03644 515313</p>
                  <p className="kontakt-note">
                    Terminvereinbarung telefonisch<br />
                    Mo - Fr: 8:00 - 18:00 Uhr
                  </p>
                </CardContent>
              </Card>

              <Card className="kontakt-card">
                <CardContent className="kontakt-card-content">
                  <Mail className="kontakt-icon" />
                  <h3 className="kontakt-title">E-Mail</h3>
                  <p className="kontakt-detail">physio.grau@gmail.com</p>
                  <p className="kontakt-note">
                    Wir antworten innerhalb von 24 Stunden
                  </p>
                </CardContent>
              </Card>

              <Card className="kontakt-card">
                <CardContent className="kontakt-card-content">
                  <MapPin className="kontakt-icon" />
                  <h3 className="kontakt-title">Adresse</h3>
                  <p className="kontakt-detail">
                    Physiotherapie Grau<br />
                    Rosestraße 4<br />
                    99510 Apolda
                  </p>
                </CardContent>
              </Card>

              <Card className="kontakt-card">
                <CardContent className="kontakt-card-content">
                  <Clock className="kontakt-icon" />
                  <h3 className="kontakt-title">Öffnungszeiten</h3>
                  <div className="oeffnungszeiten">
                    <div className="zeit-row">
                      <span className="zeit-tag">Montag - Freitag</span>
                      <span className="zeit-uhrzeit">8:00 - 18:00 Uhr</span>
                    </div>
                    <p className="kontakt-note mt-2">
                      Termine nach Vereinbarung
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="kontakt-hinweise">
              <Card className="hinweis-card">
                <CardContent className="hinweis-content">
                  <h3 className="subsection-subtitle">Terminvereinbarung</h3>
                  <p className="text-content">
                    Bitte vereinbaren Sie Ihren Termin telefonisch. So können wir 
                    sicherstellen, dass wir uns ausreichend Zeit für Sie nehmen können.
                  </p>
                  <p className="text-content">
                    Bitte bringen Sie zu Ihrem ersten Termin Ihre ärztliche Verordnung, 
                    Ihre Versichertenkarte und gegebenenfalls relevante Vorbefunde mit.
                  </p>
                  <Button asChild size="lg" className="cta-button mt-4">
                    <a href="tel:03644515313">
                      <Phone className="mr-2 h-4 w-4" />
                      Jetzt anrufen
                    </a>
                  </Button>
                </CardContent>
              </Card>

              <Card className="hinweis-card">
                <CardContent className="hinweis-content">
                  <h3 className="subsection-subtitle">Anfahrt</h3>
                  <p className="text-content">
                    Unsere Praxis befindet sich zentral in Apolda und ist gut erreichbar. 
                    Parkmöglichkeiten finden Sie in unmittelbarer Nähe.
                  </p>
                  <p className="text-content">
                    Für Patienten mit eingeschränkter Mobilität bieten wir Hausbesuche an.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Kontakt;